import * as React from 'react';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadAllAuth } from '../auth/AuthSlice';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import RouteSelection from '../routeSelection/RouteSearch';

function RouteSelectionPage() {
    const user = useSelector((state) => state.auth.user);
    const isLoading = useSelector((state) => state.auth.isLoading);
    const dispatch = useDispatch();
    const connectionsLoaded = useSelector((state) => state.auth.connectionsLoaded);
    const [, setIsLoading] = useState(false);

    // Load all auth data when user is authenticated and connections not yet loaded
    React.useEffect(() => {
        if (user && !connectionsLoaded && !isLoading) {
            dispatch(loadAllAuth());
        }
    }, [user, connectionsLoaded, isLoading, dispatch]);

    return (
        <Box sx={{
            p: { xs: 0.5, sm: 2 },
            height: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '100vw'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: { xs: 1, sm: 0 } }}>
                <Typography variant="h5" gutterBottom>
                    Select a Route
                </Typography>
            </Box>
            <Box sx={{ flex: 1, overflow: 'hidden', maxWidth: '100%' }}>
                <RouteSelection
                    setIsLoading={setIsLoading}
                    isLoading={!connectionsLoaded}
                />
            </Box>
        </Box>
    );
}

export default RouteSelectionPage;
